<div class="d-flex justify-content-end" *ngIf="!bookingId && (subtotal || (step && step !== NavigationSteps.Start))">
  <div class="lh-1 mt-1">
    <strong>Party Total: <ua-display-price [amount]="subtotal"></ua-display-price></strong>
    <br>
    <sub>Deposit: <ua-display-price [amount]="depositAmount"></ua-display-price></sub>
    <br>
    <sub><em>*does not include tax or tip</em></sub>
  </div>
</div>
